import React from "react";
import styled from "@emotion/styled";
import mq from "../utils/mediaQueries";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > h1 {
    align-self: center;
    ${mq("sm")} {
      align-self: start;
    }
  }
`;

const AbilityWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Stat = styled.p`
  font-size: 1.75rem;
`;

const Ability = ({ character }) => {
  return (
    <Wrapper>
      <h1>*** ABILITY ***</h1>
      <AbilityWrapper>
        <h1>BODY</h1>
        <Stat>{`${character.abilities.body >= 0 ? "+" : ""}${
          character.abilities.body
        }`}</Stat>
      </AbilityWrapper>
      <AbilityWrapper>
        <h1>DEXTERITY</h1>
        <Stat>{`${character.abilities.dexterity >= 0 ? "+" : ""}${
          character.abilities.dexterity
        }`}</Stat>
      </AbilityWrapper>
      <AbilityWrapper>
        <h1>SAVVY</h1>
        <Stat>{`${character.abilities.savvy >= 0 ? "+" : ""}${
          character.abilities.savvy
        }`}</Stat>
      </AbilityWrapper>
      <AbilityWrapper>
        <h1>TECH</h1>
        <Stat>{`${character.abilities.tech >= 0 ? "+" : ""}${
          character.abilities.tech
        }`}</Stat>
      </AbilityWrapper>
    </Wrapper>
  );
};

export default Ability;
